/*
 * @Author: zs
 * @Date: 2022-04-21 10:54:15
 * @LastEditTime: 2022-04-21 14:53:54
 * @Description:
 * @FilePath: \smart-community\src\api\management\management.js
 */
import request from "@/utils/request";
// 获取单位列表
export const getUnitList = data => {
  return request({
    url: "/apiData/hz-data-community/daas/dwxx/info",
    params: data || {}
  });
};

// 获取单位信息列表
export const unitList = data => {
  return request({
    url: "/api/hz-smart-community/unit/info/list",
    params: data
  });
};
// 修改单位信息详情 基本信息
export const unitupdate = data => {
  return request({
    url: "/api/hz-smart-community/unit/info/update",
    data: data,
    method: "POST"
  });
};
// 添加单位信息详情 基本信息
export const unitsave = data => {
  return request({
    url: "/api/hz-smart-community/unit/info/save",
    data: data,
    method: "POST"
  });
};
// 获取单位信息列表
export const infoQuery = data => {
  return request({
    url: "/api/hz-smart-community/unit/info/info/" + data,
    params: data
  });
};

export const unitsavePrison = data => {
  return request({
    url: "/api/hz-smart-community/unit/info/savePrison",
    data: data,
    method: "POST"
  });
};
export const unitdeletePrison = data => {
  return request({
    url: "/api/hz-smart-community/unit/info/deletePrison",
    data: data,
    method: "POST"
  });
};

// 删除实有单位
export const unitdelete = data => {
  return request({
    url: "/api/hz-smart-community/unit/info/delete",
    data: data,
    method: "POST"
  });
};